import React from "react";
import { Avatar, Box, Card, CardContent, CardHeader, Chip, Divider, Stack, TablePagination, Typography } from "@mui/material";

function getUserInitial(user) {
    if (!user) return "?";
    const first = String(user.first_name || "").trim()[0];
    const last = String(user.last_name || "").trim()[0];
    return (first || last || "?").toUpperCase();
}

export default function StudentsListCard({ students, total, page, perPage, onPageChange }) {
    return (
        <Card variant="outlined" sx={{ minHeight: { xs: "auto", md: 520 }, display: "flex", flexDirection: "column", minWidth: 0 }}>
            <CardHeader title="Students" />
            <Divider />
            <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden", pt: 2, pb: 0, "&:last-child": { pb: 0 } }}>
                <Box sx={{ flex: 1, minHeight: 0, overflow: "auto", pb: 1 }}>
                    {students.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">No students enrolled.</Typography>
                    ) : (
                        <Stack spacing={1.5}>
                            {students.map((row) => {
                                const s = row.student;
                                const name = s ? `${s.first_name || ""} ${s.last_name || ""}`.trim() : `User #${row.student_id}`;
                                return (
                                    <Stack key={row.id} direction="row" spacing={1.5} alignItems="flex-start" sx={{ py: 1.5, px: 2, borderRadius: 1, bgcolor: "action.hover" }}>
                                        {s?.avatar ? (
                                            <Avatar src={s.avatar} alt={name} sx={{ width: 48, height: 48, flexShrink: 0 }} />
                                        ) : (
                                            <Avatar sx={{ width: 48, height: 48, flexShrink: 0, fontSize: "1.1rem" }}>{s ? getUserInitial(s) : "?"}</Avatar>
                                        )}
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography sx={{ fontWeight: 600, mb: 0.25 }}>{name}</Typography>
                                            <Typography variant="body2" color="text.secondary">{s?.email || "—"}</Typography>
                                            <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} flexWrap="wrap">
                                                <Chip size="small" label={`Allowed: ${row.lessons_allowed ?? 0}`} variant="outlined" />
                                                <Chip size="small" label={`Attendances: ${row.present_attendances ?? 0}/${row.attendance_marked_lessons ?? 0}`} variant="outlined" />
                                                <Chip size="small" label={`Homework: ${row.homework_done_count ?? 0}/${row.homework_marked_lessons_count ?? 0}`} variant="outlined" />
                                                <Chip size="small" label={`Assignments: ${row.assignment_rated_count ?? 0}/${row.assignment_total_count ?? 0}`} variant="outlined" />
                                                <Chip size="small" label={`Progress: ${row.assignment_progress_percent == null ? "—" : `${Number(row.assignment_progress_percent).toFixed(1)}%`}`} variant="outlined" />
                                                {row.status ? <Chip size="small" label={row.status} /> : null}
                                            </Stack>
                                        </Box>
                                    </Stack>
                                );
                            })}
                        </Stack>
                    )}
                </Box>
                <TablePagination
                    component="div"
                    count={total}
                    page={page - 1}
                    rowsPerPage={perPage}
                    onPageChange={(_, p) => onPageChange(p + 1)}
                    rowsPerPageOptions={[]}
                    sx={{ flexShrink: 0, borderTop: 1, borderColor: "divider", mt: "auto" }}
                />
            </CardContent>
        </Card>
    );
}

